import {connectToStores} from 'epic-alt-utils';
import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router';

import ForumSunsetStore from '../../stores/ForumSunsetStore';

/**
 * Terms & Policy View
 */
@connectToStores
class ForumSunsetView extends React.Component {
  static propTypes = {
    forumSunsetStore: PropTypes.object,
  };

  static getStores() {
    return [ForumSunsetStore];
  }

  static getPropsFromStores() {
    return {
      forumSunsetStore: ForumSunsetStore.getState(),
    };
  }
  render() {
    return (
      <div className="forumSunset">
        <div
          className="content"
          dangerouslySetInnerHTML={{
            __html: this.props.forumSunsetStore.forumSunsetData.content,
          }}
        />
      </div>
    );
  }
}

export default withRouter(ForumSunsetView);
